// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"ItemTemplateForm_saveButton__2kaCF","form":"ItemTemplateForm_form__1a9-J"};